<template>
  <section :id="computedId" :class="classWrapper">
    <header v-if="title || description" :class="classHeader">
      <component
        :is="titleTag"
        v-if="title"
        :class="classTitle"
        v-html="pageTitle"
      ></component>
      <p
        v-if="pageDescription"
        :class="classDescription"
        v-html="pageDescription"
      ></p>
    </header>
    <slot />
  </section>
</template>

<script>
import slugify from "slugify";
import { mapState } from "vuex";

export default {
  name: "Page",
  props: {
    id: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    titleTag: {
      type: String,
      default: "h1"
    },
    classPrefix: {
      type: String,
      default: "page"
    }
  },

  computed: {
    computedId() {
      return this.id || slugify(this.title).toLowerCase();
    },
    classWrapper() {
      return this.classPrefix;
    },
    classHeader() {
      return `${this.classPrefix}__header`;
    },
    classTitle() {
      return `${this.classPrefix}__title`;
    },
    classDescription() {
      return `${this.classPrefix}__description`;
    },
    ...mapState("App", ["pageTitle", "pageDescription"])
  },

  watch: {
    title(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setPageTitle();
      }
    }
  },

  created() {
    this.setPageTitle();
  },

  methods: {
    setPageTitle() {
      if (this.$options._componentTag === "Page") {
        this.$store.commit("App/setPageTitle", this.title);
        this.$store.commit("App/setPageDescription", this.description);
      }
    }
  }
};
</script>

<style lang="scss"></style>
